import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { useEditorDisabled } from "../use-editor-disabled";

export const Unlink: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Unlink
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
        />
    );
};

Unlink.displayName = "RichTextEditor.Unlink";
